export function TermsPage() {
  return (
    <main className="section page pb-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <header className="mb-12">
          <p className="eyebrow text-magma">Regole d'Ingaggio</p>
          <h1 className="text-4xl md:text-5xl font-display uppercase tracking-wider mb-4 text-white">Termini di Servizio</h1>
          <p className="text-neutral-400 text-sm">Ultimo aggiornamento: 28 Luglio 2026</p>
        </header>

        <div className="space-y-12 text-neutral-300 leading-relaxed">
          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">1. Accettazione dei Termini</h2>
            <p>
              L'accesso e l'utilizzo del sito web <strong>blastcore.it</strong> e del server Minecraft <strong>play.blastcore.it</strong> (collettivamente "BlastCore" o "Servizio") costituiscono l'esplicita accettazione dei presenti Termini di Servizio. Se non sei d'accordo con una qualsiasi parte di questi termini, sei invitato a interrompere immediatamente l'utilizzo del Servizio.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">2. Descrizione del Servizio</h2>
            <p>
              BlastCore è un network Minecraft competitivo focalizzato esclusivamente sulla modalità TNTWars. Il sito web fornisce classifiche (leaderboard), profili giocatore, storico partite, informazioni sui tornei e sullo stato del server. I dati mostrati sul sito riflettono e dipendono dall'attività di gioco che avviene all'interno del server Minecraft.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">3. Assenza di Affiliazione</h2>
            <div className="bg-obsidian border border-neutral-800 p-5 rounded-md font-bold text-neutral-300 border-l-4 border-l-neutral-500">
              <p>NOT AN OFFICIAL MINECRAFT PRODUCT. NOT APPROVED BY OR ASSOCIATED WITH MOJANG OR MICROSOFT.</p>
              <p className="mt-2 font-normal text-sm">
                BlastCore non è un prodotto ufficiale di Minecraft. Non è in alcun modo approvato o associato a Mojang AB o Microsoft Corporation. "Minecraft" è un marchio registrato di Mojang Synergies AB.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">4. Regole di Condotta e Integrità Competitiva</h2>
            <p className="mb-4">Il cuore di BlastCore è la competizione leale. Accedendo al server di gioco, l'utente si impegna a rispettare il seguente codice di condotta:</p>
            <ul className="list-none space-y-4">
              <li className="bg-obsidian p-4 rounded-md border border-neutral-800">
                <strong className="text-magma text-lg font-display uppercase tracking-wider block mb-1">Divieto di Cheating</strong>
                <p>L'uso di client modificati (es. hack, x-ray, pvp client non consentiti, autoclicker), macro, o script esterni che conferiscono un vantaggio sleale è severamente vietato e comporta il ban permanente.</p>
              </li>
              <li className="bg-obsidian p-4 rounded-md border border-neutral-800">
                <strong className="text-magma text-lg font-display uppercase tracking-wider block mb-1">Divieto di Exploit</strong>
                <p>L'abuso intenzionale di bug, glitch del server o difetti delle meccaniche di gioco per ottenere vantaggi (es. duplicazione TNT, manipolazione dell'invulnerabilità) comporterà sanzioni sulle statistiche e sospensioni.</p>
              </li>
              <li className="bg-obsidian p-4 rounded-md border border-neutral-800">
                <strong className="text-magma text-lg font-display uppercase tracking-wider block mb-1">Manipolazione MMR e Classifiche</strong>
                <p>Il "boosting" (accordarsi con avversari per vincere), l'uso di account alternativi (smurfing malevolo per rovinare il ranking altrui) o il "win-trading" sono proibiti. I giocatori identificati subiranno l'azzeramento del MMR.</p>
              </li>
              <li className="bg-obsidian p-4 rounded-md border border-neutral-800">
                <strong className="text-magma text-lg font-display uppercase tracking-wider block mb-1">Comportamento Tossico</strong>
                <p>Non è tollerato alcun comportamento discriminatorio, linguaggio d'odio, molestia persistente o doxing, né in chat pubblica né nei messaggi privati.</p>
              </li>
            </ul>
            <p className="mt-4"><strong>Sanzioni e Moderazione:</strong> Lo staff di BlastCore si riserva il diritto insindacabile di moderare, sospendere o bandire temporaneamente o permanentemente dal network i giocatori che violano queste regole.</p>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">5. Statistiche, Classifiche e Tornei</h2>
            <p className="mb-3">
              I dati di gioco registrati (MMR, vittorie, uccisioni, e partecipazione ai tornei) sono calcolati dai nostri sistemi interni.
            </p>
            <ul className="list-disc list-inside space-y-1 ml-2 text-neutral-400">
              <li>BlastCore non garantisce la precisione infallibile del tracciamento (possono verificarsi problemi tecnici, crash o rollback).</li>
              <li>L'amministrazione si riserva il diritto di ricalcolare, resettare (es. nuova stagione competitiva) o correggere manualmente i punteggi.</li>
              <li>Le vittorie e i premi dei tornei sono soggetti a verifica anti-cheat a posteriori; in caso di esito positivo ai controlli per frode, il titolo e l'eventuale premio verranno revocati.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">6. Proprietà Intellettuale</h2>
            <p>
              Fatti salvi i diritti di Mojang AB su Minecraft e i suoi asset base, tutto il contenuto originale di BlastCore, inclusi ma non limitati a: il codice sorgente custom dei plugin di gioco, il design del sito web ("Kinetic Obsidian" UI), i loghi, l'infrastruttura backend e le meccaniche di gioco esclusive, costituiscono proprietà intellettuale protetta e non possono essere copiati, decodificati (reverse-engineered) o redistribuiti senza autorizzazione scritta.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">7. Limitazione di Responsabilità</h2>
            <p>
              Nei limiti massimi consentiti dal diritto applicabile, il Servizio è fornito "così com'è" e "come disponibile". BlastCore non offre alcuna garanzia sulla disponibilità ininterrotta del server di gioco o del sito web, sull'assenza di lag, o sulla preservazione in perpetuo delle statistiche di gioco. 
            </p>
            <p className="mt-2">
              BlastCore non potrà essere ritenuta responsabile per eventuali danni diretti o indiretti derivanti dall'utilizzo o dall'impossibilità di accedere al Servizio, o da azioni di terzi intraprese all'interno della community.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">8. Modifiche ai Termini</h2>
            <p>
              Ci riserviamo il diritto di aggiornare o modificare i presenti Termini di Servizio in qualsiasi momento, in risposta a necessità legali, tecniche o di bilanciamento del gioco. Le modifiche rilevanti verranno comunicate sul sito web o sul server Discord della community (se presente). L'accesso continuo al server dopo tali modifiche equivale all'accettazione dei nuovi Termini.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide">9. Foro Competente e Contatti</h2>
            <p>
              I presenti Termini sono governati dalla Legge Italiana. Qualora l'utente rivesta la qualifica di "Consumatore" ai sensi del Codice del Consumo italiano, per ogni controversia sarà competente il foro di residenza dell'utente.
            </p>
            <p className="mt-4">
              Per comunicazioni legali, contestazioni di ban (appeal) o chiarimenti sui presenti Termini, è possibile contattarci all'indirizzo email: <strong>info@blastcore.it</strong>
            </p>
          </section>
        </div>
      </div>
    </main>
  )
}
